import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { deleteAttribute } from '../../../../services/dtServices'
import { IAttribute } from '../../interfaces'

export const useDeleteAttribute = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteAttribute>>,
    Error,
    string
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (attributeId: string) => {
            return deleteAttribute(orgId, entityId, attributeId)
        },
        //client side optimistic update
        onMutate: (attributeId: string) => {
            queryClient.setQueryData(
                ['attributes', entityId, orgId],
                (prevAttributes: IAttribute[]) =>
                    prevAttributes?.filter(
                        (attribute: IAttribute) => attribute.id !== attributeId,
                    ),
            )
        },
        //refetch attributes after mutation,
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['attributes', entityId, orgId],
            }),
    })
}
